import { render, staticRenderFns } from "./PermissionError.vue?vue&type=template&id=05a2ef90&"
import script from "./PermissionError.vue?vue&type=script&lang=js&"
export * from "./PermissionError.vue?vue&type=script&lang=js&"
import style0 from "./PermissionError.vue?vue&type=style&index=0&id=05a2ef90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports